import {
  unstable_HistoryRouter as HistoryRouter,
  Routes,
  Route,
} from "react-router-dom"

import history from "utils/history"

import { ROUTES } from "routes/routerConfig"
import PrivateRoute from "routes/PrivateRoute"
import { IRoute } from "types/shared"

import LaundryProvider from "providers/LaundryProvider"
import SettingsProvider from "providers/SettingsProvider"

const RoutesLayout = () => {
  return (
    <HistoryRouter history={history}>
      <LaundryProvider>
        <SettingsProvider>
          <Routes>
              {ROUTES.map((route: IRoute) => (
                <Route
                  key={route.path}
                  path={route.path}
                  element={
                    route.isPrivate ? (
                      <PrivateRoute allowedRoles={route.allowedRoles}>
                        {route.element}
                      </PrivateRoute>
                    ) : (
                      route.element
                    )
                  }
                />
              ))}
          </Routes>
        </SettingsProvider>
      </LaundryProvider>
    </HistoryRouter>
  )
}

export default RoutesLayout
